import { Store, select } from '@ngrx/store';
import {
  createSelector,
  createFeatureSelector,
  ActionReducerMap
} from '@ngrx/store';
import * as fromProduct from './products.reducer';
import { Product } from '../../product.model';

// export const reducers: ActionReducerMap<any> = {
//   message: fromProduct.productReducer
// };

export const selectProductState = createFeatureSelector<fromProduct.State>('productReducer');


export const { selectAll: selectAllProducts } = fromProduct.productAdapter.getSelectors(
  selectProductState
);

export const { selectTotal: selectTotalProducts } = fromProduct.productAdapter.getSelectors(
  selectProductState
);

export const selectAddProductCompleted = createSelector(selectProductState,
  fromProduct.getProductStatus
);

export const {
  selectIds: productIds,
  selectEntities: productEntities,
  selectAll: allProducts,
  selectTotal: totalProducts
} = fromProduct.productAdapter.getSelectors(selectProductState);

export const selectProductsByCompanyId = createSelector(
  allProducts,
  (products: Product[], { id }: { id: string }) => products.filter(product => product.companyId === id)
);

export const selectProductsByCompanyIdSiteId = createSelector(
  allProducts,
  (products: Product[], { companyId, siteId }: { companyId: string, siteId: string }) => products.filter(product => product.companyId === companyId && product.siteId === siteId)
);

export const countProductsByCompanyIdSiteId = createSelector(
  totalProducts,
  (state) => {
    return state;
  }
);

// export const countProductsByCompanyIdSiteId = createSelector(
//   selectProductState,
//   productsState => {
//     return fromProduct.productAdapter.getSelectors().selectTotal;
//   }
// );


export const selectAllCourses = createSelector(
  selectProductState,
  productsState => {
    const allCourses = Object.values(productsState.entities);
    allCourses.sort();
    return allCourses;
  }
);

export interface FeatureState {
  counter: number;
}

export interface AppState {
  feature: FeatureState;
  allProducts: Product[];
}

// export const selectFeature = createFeatureSelector<AppState, FeatureState>('feature');
export const selectFeature = (state: AppState) => state.feature;

export const selectFeatureCount = createSelector(
  selectFeature,
  (state: FeatureState) => state.counter
);
